import { copyFor } from 'config';

const getCopy = copyFor('solar.personalEnergyProduction');

interface PersonalEnergyProductionCopy {
  body: string;
  liveBody: string;
  emptyPlaceholder: string;
  kwhLabel: string;
  solarCreditsLabel: string;
  title: string;
  allocation: {
    size: string;
    label: string;
    tooltip: { copy: string; label: string };
  };
}

interface CopyParams {
  calculatedAllocationKw?: number | null;
}

export const getPersonalEnergyProductionCopy = (
  params: CopyParams
): PersonalEnergyProductionCopy => {
  const personalEnergyProductionCopy = getCopy('waitlist');
  const { calculatedAllocationKw } = params;
  personalEnergyProductionCopy.allocation.size = calculatedAllocationKw
    ? getCopy('waitlist.allocation.size', {
        calculatedAllocationKw: Math.round(calculatedAllocationKw),
      })
    : getCopy('waitlist.emptyPlaceholder');
  return personalEnergyProductionCopy;
};
